// extracted by mini-css-extract-plugin
export default {"button":"EditButton_button__a7tdC"};